import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=2dc5f4d2&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=2dc5f4d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5f4d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2dc5f4d2', component.options)
    } else {
      api.reload('2dc5f4d2', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=2dc5f4d2&scoped=true&", function () {
      api.rerender('2dc5f4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/front/modules/signup/pages/Page.vue"
export default component.exports